/* eslint-disable global-require */
/* eslint-disable max-classes-per-file */
import {
  PlaceIconType,
  PlaceIconTypeActive,
  PlaceTypesNames,
} from 'app/constants/place.constant';
import entityMarker from './emptyMarker';
import { Point } from '../map/drive/Point';

const ViaPoint = ({ lat, lng, map }) => {
  return new entityMarker({
    srcBase: require('static/images/icons/via_sm_deact.png'),
    srcHover: require('static/images/icons/via_sm_deacta.png'),
    map,
    lat,
    lng,
    type: 'via',
    draggable: false,
  });
};
const EndPoint = ({ lat, lng, map }) => {
  return new entityMarker({
    srcBase: require('static/images/icons/end_point.svg'),
    srcHover: require('static/images/icons/end_point_selected.svg'),
    map,
    lat,
    lng,
    type: 'end',
    draggable: false,
  });
};

class StartTourPoint extends Point {
  constructor({ lat, lng, map, tourId }) {
    super({
      srcBase: require('static/images/icons/start_point.svg'),
      srcHover: require('static/images/icons/start_point_selected.svg'),
      map,
      lat,
      lng,
      draggable: false,
      type: 'active',
      id: tourId,
    });
  }
}

const PlacePoint = ({ map, data }) => {
  const options = data.options ? data.options : {};
  const { category = 1 } = options;

  const entity = new entityMarker({
    srcBase: PlaceIconType[category],
    srcHover: PlaceIconTypeActive[category],
    map,
    lat: data.lat,
    lng: data.lng,
    id: data.id,
    iconAnchor: [13, 34],
    scope: 'place_active',
    iconType: PlaceTypesNames[category],
  });

  return entity;
};

export class TourPointFactory {
  createPoint(options) {
    switch (options.pointType) {
      case Point.Type.START:
        this.pointType = StartTourPoint;
        break;
      case Point.Type.VIA:
        this.pointType = ViaPoint;
        break;
      case Point.Type.END:
        this.pointType = EndPoint;
        break;
      case Point.Type.PLACE:
        this.pointType = PlacePoint;
        break;
      default:
        this.pointType = StartTourPoint;
    }
    return new this.pointType(options);
  }
}

export const StartPoint = (lat, lng, map) => {
  return new entityMarker({
    srcBase: require('static/images/icons/start_point.svg'),
    srcHover: require('static/images/icons/start_point_selected.svg'),
    map,
    lat,
    lng,
  });
};
